<div class="page-header d-lg-none" [ngClass]="{ 'hide-footer': !showFooter }">
  <div class="header-row d-flex align-items-center text-white">
    <div class="banner-name">
      <a (click)="goBack()" class="btn back-btn text-white px-0 z-2">
        <span class="icon material-icons" aria-hidden="true">arrow_back_ios</span>
      </a>
      <h4 class="page-title mb-0" [ngClass]="{ 'text-title-center': !showBalance || showPointsPill }">
        {{ pageTitle | translate }}
      </h4>
    </div>
    @if (showBalance && !showPointsPill) {
      <div class="ms-auto d-flex align-items-center font-size-14 widget-details">
        <button class="qrcode-btn text-white bg-glass" (click)="goToWallet()">
          <span class="icon material-icons material-mobile-nav">qr_code_2</span>
        </button>
      </div>
    }
  </div>
  @if (showPointsPill) {
    <div class="points-pill d-flex align-items-center justify-content-between bg-glass text-white w-100">
      <span class="font-size-12">Your Points</span>
      <div class="d-flex align-items-center gap-2">
        <span class="icon material-icons points-pill-icon">loyalty</span>
        <span class="font-size-18">{{ pointsBalance$ | async | number: '1.0-0' : 'en-GB' }}</span>
      </div>
    </div>
  }
</div>
